
    <ul id="breadCrumb">
        <li>
          <a [routerLink]="">Home</a>
          <svg class="icon chev-right"><use xlink:href="assets/iconography/symbol-defs.svg#icon-chev-right"></use></svg>        
        </li>
        <li *ngFor="let breadcrumb of breadcrumbs;">
          <span>
            {{ breadcrumb.label }}
          </span>       
          <svg class="icon chev-right"><use xlink:href="assets/iconography/symbol-defs.svg#icon-chev-right"></use></svg>        
        </li>
    </ul>
  